import { motion, useReducedMotion } from "framer-motion";
import { EASE } from "../lib/motion";

export const Hero = () => {
  const reduce = useReducedMotion();
  const rise = (y, duration, delay) => ({
    initial: { opacity: 0, ...(reduce ? {} : { y }) },
    animate: { opacity: 1, y: 0 },
    transition: { duration, delay, ease: EASE },
  });

  return (
    <section data-testid="evc-hero">
      <motion.div className="evc-eyebrow" {...rise(8, 0.6, 0.1)}>
        Governing technology spend &middot; Proving business value
      </motion.div>

      <motion.h1 className="evc-h1" {...rise(12, 0.8, 0.2)}>
        How much of your IT spend can you <span className="accent">actually defend?</span>
      </motion.h1>

      <motion.p className="evc-lede" {...rise(8, 0.6, 0.3)}>
        Most IT organisations manage technology spend. Few can <em>explain it</em>, <em>price it</em>,
        or <em>prove what it returns</em>. This is a structured, evidence-based diagnostic of how
        defensible your spend really is - and how far you've moved from defending cost to demonstrating
        value. Benchmarked against a maturity ladder used in real consulting engagements.
      </motion.p>
    </section>
  );
};
